<form [formGroup]="formGroup">
  <div class="row flex-between-center">
    <div class="col-2">
      <app-validated-dropdown
        [inputFormControl]="formGroup.controls.title"
        inputFormControlName="title"
        label="general.nameTitle"
        [leaveSpaceForValidation]="true"
        [loading]="!store.allLoaded() || store.nameTitlesEntities().length === 0"
        [optionsStamp]="store.nameTitlesEntities().length"
      >
        <option
          *ngFor="let nameTitle of store.nameTitlesEntities()"
          [value]="nameTitle.code"
        >
          {{ nameTitle.localized | getLocalized }}
        </option>
      </app-validated-dropdown>
    </div>
    <div class="col">
      <app-validated-input
        [inputFormControl]="formGroup.controls.familyName"
        inputFormControlName="familyName"
        label="general.lastName"
        [leaveSpaceForValidation]="true"
      ></app-validated-input>
    </div>
    <div class="col">
      <app-validated-input
        [inputFormControl]="formGroup.controls.middleName"
        inputFormControlName="middleName"
        label="general.middleName"
        [leaveSpaceForValidation]="true"
      ></app-validated-input>
    </div>
    <div class="col">
      <app-validated-input
        [inputFormControl]="formGroup.controls.givenName"
        inputFormControlName="givenName"
        label="general.firstName"
        [leaveSpaceForValidation]="true"
      ></app-validated-input>
    </div>
  </div>
  <div class="row flex-between-center mb-4">
    <app-validated-dropdown
      [inputFormControl]="formGroup.controls.citizenship"
      inputFormControlName="citizenship"
      label="registrationWizard.personalDataForm.citizenship"
      [loading]="!store.allLoaded()"
      [optionsStamp]="store.countriesEntities().length"
    >
      <option
        *ngFor="let country of store.countriesEntities()"
        [value]="country.code"
      >
        {{ country.localized | getLocalized }}
      </option>
    </app-validated-dropdown>
  </div>
  <!-- birthData -->
  <div class="card mb-4">
    <div class="card-header">
      {{ "registrationWizard.personalDataForm.birthName" | translate }}
    </div>
    <div class="card-body">
      <div class="row flex-between-center">
        <div class="col">
          <app-validated-input
            [inputFormControl]="formGroup.controls.birthLastName"
            inputFormControlName="birthLastName"
            label="general.lastName"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
        <div class="col">
          <app-validated-input
            [inputFormControl]="formGroup.controls.birthMiddleName"
            inputFormControlName="birthMiddleName"
            label="general.middleName"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
        <div class="col">
          <app-validated-input
            [inputFormControl]="formGroup.controls.birthFirstName"
            inputFormControlName="birthFirstName"
            label="general.firstName"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
      </div>
    </div>
  </div>

  <div class="row flex mb-4">
    <div class="col-auto my-2">
      <app-validated-input
        [inputFormControl]="formGroup.controls.birthPlace"
        inputFormControlName="birthPlace"
        label="registrationWizard.personalDataForm.birtPlace"
        [leaveSpaceForValidation]="true"
      ></app-validated-input>
    </div>
    <div class="col-auto my-2">
      <app-validated-date-picker
        [inputFormControl]="formGroup.controls.dateOfBirth"
        inputFormControlName="dateOfBirth"
        label="registrationWizard.personalDataForm.dateOfBirth"
        [leaveSpaceForValidation]="true"
      ></app-validated-date-picker>
    </div>
  </div>

  <!-- mother's name -->
  <div class="card mb-4">
    <div class="card-header">
      {{ "registrationWizard.personalDataForm.mothersMaidenName" | translate }}
    </div>
    <div class="card-body">
      <div class="row flex-between-center">
        <div class="col">
          <app-validated-input
            [inputFormControl]="formGroup.controls.motherLastName"
            inputFormControlName="motherLastName"
            label="general.lastName"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
        <div class="col">
          <app-validated-input
            [inputFormControl]="formGroup.controls.motherMiddleName"
            inputFormControlName="motherMiddleName"
            label="general.middleName"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
        <div class="col">
          <app-validated-input
            [inputFormControl]="formGroup.controls.motherFirstName"
            inputFormControlName="motherFirstName"
            label="general.firstName"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
      </div>
    </div>
  </div>

  <!-- Certificate -->
  <div class="card mb-4">
    <div class="card-header">
      {{ "registrationWizard.personalDataForm.certificate" | translate }}
    </div>
    <div class="card-body">
      <div class="row flex-between-center">
        <div class="col">
          <app-validated-dropdown
            [inputFormControl]="formGroup.controls.certificateType"
            inputFormControlName="certificateType"
            label="general.typeOf"
            [leaveSpaceForValidation]="true"
            [loading]="!store.allLoaded()"
            [optionsStamp]="store.idCardTypeEntities().length"
          >
            <option
              *ngFor="let idCardType of store.idCardTypeEntities()"
              [value]="idCardType.id"
            >
              {{ "generic.idCardType." + idCardType.name | translate }}
            </option>
          </app-validated-dropdown>
        </div>
        <div class="col">
          <app-validated-input
            [inputFormControl]="formGroup.controls.numberOfCertificate"
            inputFormControlName="numberOfCertificate"
            label="registrationWizard.personalDataForm.numberOf"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
        <div class="col">
          <app-validated-date-picker
            [inputFormControl]="formGroup.controls.expiryDate"
            inputFormControlName="expiryDate"
            label="registrationWizard.personalDataForm.expiryDate"
            [leaveSpaceForValidation]="true"
          ></app-validated-date-picker>
        </div>
      </div>
    </div>
  </div>

  <!-- Permament address -->
  <div class="card mb-4">
    <div class="card-header">
      {{ "registrationWizard.personalDataForm.permamentAddress" | translate }}
    </div>
    <div class="card-body">
      <app-validated-dropdown
        [inputFormControl]="formGroup.controls.country"
        inputFormControlName="country"
        label="general.country"
        [loading]="!store.allLoaded()"
        [optionsStamp]="store.countriesEntities().length"
      >
        <option
          *ngFor="let country of store.countriesEntities()"
          [value]="country.code"
        >
          {{ country.localized | getLocalized }}
        </option>
      </app-validated-dropdown>
      <app-validated-input
        [inputFormControl]="formGroup.controls.postalCode"
        inputFormControlName="postalCode"
        label="general.postalCode"
      ></app-validated-input>
      <app-validated-input
        [inputFormControl]="formGroup.controls.city"
        inputFormControlName="city"
        label="general.city"
      ></app-validated-input>
      <div class="row d-flex flex-nowrap">
        <div class="col flex-fill">
          <app-validated-input
            [inputFormControl]="formGroup.controls.publicSpace"
            inputFormControlName="publicSpace"
            label="general.publicSpace"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
        <div class="col flex-fill">
          <app-validated-dropdown
            [inputFormControl]="formGroup.controls.publicSpaceType"
            inputFormControlName="publicSpaceType"
            label="general.publicSpaceType"
            [leaveSpaceForValidation]="true"
            [loading]="!store.allLoaded()"
            [optionsStamp]="store.publicSpaceTypeEntities().length"
          >
            <option
              *ngFor="let publicSpaceType of store.publicSpaceTypeEntities()"
              [value]="publicSpaceType.id"
            >
              {{
                "generic.publicSpaceType." + publicSpaceType.name | translate
              }}
            </option>
          </app-validated-dropdown>
        </div>
        <div class="col flex-fill">
          <app-validated-input
            [inputFormControl]="formGroup.controls.houseNumber"
            inputFormControlName="houseNumber"
            label="general.houseNumber"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
        <div class="col flex-fill">
          <app-validated-input
            [inputFormControl]="formGroup.controls.doorOrFloor"
            inputFormControlName="doorOrFloor"
            label="general.doorOrFloor"
            [leaveSpaceForValidation]="true"
          ></app-validated-input>
        </div>
      </div>
    </div>
  </div>

  <!-- Optional Data -->
  <div class="card mb-4">
    <div class="card-header">
      {{ "general.optionalData" | translate }}
    </div>
    <div class="card-body">
      <app-validated-input
        [inputFormControl]="formGroup.controls.optionalTaxNumber"
        inputFormControlName="optionalTaxNumber"
        label="general.optionalTaxNumber"
      ></app-validated-input>
      <app-validated-input
        [inputFormControl]="formGroup.controls.optionalBankNumber"
        inputFormControlName="optionalBankNumber"
        label="general.optionalBankNumber"
      ></app-validated-input>
    </div>
  </div>
</form>
